import { render, staticRenderFns } from "./StudentCouponVouchers.vue?vue&type=template&id=2fbcde25"
import script from "./StudentCouponVouchers.vue?vue&type=script&lang=ts"
export * from "./StudentCouponVouchers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports